import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import DiagnosticDoctorAddition from "./DiagnosticDoctorAddition";
import DiagnosticDoctorList from "./DiagnosticDoctorList";
import { fetchServiceMasterLookups, getStates } from "../api/diagnosticDoctorApi";

/**
 * Diagnostic Doctor Management — Radiologist / Pathologist admin screen.
 * Shared lookups/states are fetched once here so add + list do not duplicate calls.
 */
function DiagnosticDoctorManagement() {
  const [refreshList, setRefreshList] = useState(0);
  const [lookups, setLookups] = useState({ groups: [], classifications: [] });
  const [states, setStates] = useState([]);

  useEffect(() => {
    let cancelled = false;

    Promise.all([fetchServiceMasterLookups(), getStates()])
      .then(([lookupData, stateList]) => {
        if (!cancelled) {
          setLookups(lookupData);
          setStates(stateList);
        }
      })
      .catch((err) => {
        console.error("DiagnosticDoctorManagement bootstrap:", err);
        if (!cancelled) {
          toast.error("Could not load form data");
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <DiagnosticDoctorAddition
        updateList={() => setRefreshList((n) => n + 1)}
        lookups={lookups}
        states={states}
      />
      <DiagnosticDoctorList refreshList={refreshList} lookups={lookups} />
    </div>
  );
}

export default DiagnosticDoctorManagement;
